import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Content = styled.div`
    width:100%;
    padding:1.2rem 2rem;
    background:#fff;
    border-radius: 5px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    height:75vh;
    margin-top: 1rem;
    position: relative;
`;

export const TitleLeft = styled.div`
    display:flex;
    flex-direction: row;
    gap:1rem;
    justify-content: space-between;
    align-self: end;
    span:nth-of-type(1){
        font-size: 20px;
        font-weight: 600;
    }
    span:nth-of-type(2){
        color:#414141;
        font-size: 14px;
        font-weight: 500;
        height: 100%;
        margin-top: auto;
    }
`;

export const DataListWrap = styled.div`
    height:calc(100% - 98px );
    overflow:auto;  
    scrollbar-width: thin;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: darkgrey;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

        &:last-of-type{
            text-align: right;
        }
    }

    tr:nth-of-type(even){
            background:#a7a7a71f;
    }

    span{
        display:block;
        white-space: nowrap;
    }
`;

export const Td = styled.td<{}>`
    font-size: 16px !important;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    font-weight: 600;

    svg{
        height:14px;
    }
    &:hover{
        background:#f8f8f8;
    }
`;

export const Img = styled.div`
    width:34px;
    height:34px; 
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
`;

export const PickButton = styled.button`
    font-size: 11px;
    font-weight: 400;
    background:#2A848E;
    color:#fff;
    padding:0.5rem 1rem;
    border-radius: 5px;
    white-space: nowrap;

    &:hover{
        opacity: 0.8;
    }
`;

export const EditContent = styled.div<{aproved?:boolean}>`
    display:flex;
    align-items: center;
    gap:0.5rem;
    font-size: 14px;
    cursor: pointer;
    color:${props => props.aproved?"#2A848E":"#FA505E"};

    svg{
        height:14px;

        path{
            fill:${props => props.aproved?"#2A848E":"#FA505E"};
        }

        
    }

    :hover{
        opacity: 0.8;
    }
`;

export const ActionBar = styled.div<{ left?: boolean }>`
    display:flex;
    align-items: center;
    gap:1rem;
    margin-left: auto;
    justify-content:${props => props.left ? "start" : "end"};
    font-size: 16px;

    svg{
        cursor: pointer;
        height:16px;

        path{
            fill:#888888;
        }

        :hover{
            opacity: 0.8;
        }
    }
`;

export const PopupWrapper = styled.div`
    width:480px;
    background:#fff;
    border-radius: 10px;
    overflow: visible;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
`;

export const TopBar = styled.div`
    background: #efefef;
    font-size: 20px;
    font-weight: 500;
    display:flex;
    align-items: center;
    padding: 0.5rem 1.5rem;
    border-radius: 10px 10px 0 0;

    button{
        height: 26px;
        border-radius: 50%;
        aspect-ratio: 1 / 1;
        margin-left: auto;
        background:#2A848E;
        display:flex;
        align-items: center;
        justify-content: center;
        transition: all 0.1s ease-in-out;

        svg{
            height:44%;
            path{
                fill:#fff;
            }
        }

        &:hover{
            opacity: 0.8;
        }
    }
`;

export const PopupContent = styled.div`
    padding:1rem 1.5rem 0.5rem 1.5rem;

    span{
        display:block;
        font-size: 16px;
    }

    p{
        font-size: 12px;
        margin-bottom: 0.4rem;
        margin-top: 1rem;
    }
    
    textarea{
        font-size: 14px;
        width:100%;
        height:90px;
        resize: none;
        border-radius: 5px;
        padding:1rem;
        outline:none;
        border-color:#acacac;
    }
`;

export const BtnRow = styled.div`
    padding: 0.5rem 1.5rem 1.5rem 1.5rem;
    display:flex;
    justify-content: end;
    gap:2.5rem;

    button{
        max-width: 130px;
        width:100%;
        font-size: 14px;
        padding:0.5rem;
        border-radius: 5px;
        transition: all 0.1s ease-in-out;
        border: 1px solid #acacac;
        color:#868686;

        :nth-of-type(1){
            border: 1px solid #2A848E;
            color:#2A848E;
        }

        :nth-of-type(2){
            border: 1px solid #FA505E;
            color:#FA505E;
        }

        &:hover{
            opacity: 0.8;
            background:#acacac;
            color:#fff;
            

            :nth-of-type(1){
                background:#2A848E;
            }
            :nth-of-type(2){
                background:#FA505E;
            }
        }

        :disabled{
            background-color: transparent !important;
            color: #666666 !important;
            border: 1px solid #acacac;
            cursor: not-allowed;
        }
    }
`;